export default "__VITE_ASSET__C5u97TRa__"